import React from 'react';
import FlagColombia from '../CustomIcons/Flags/FlagColombia';
import ControlledNumberInput from './ControlledNumberInput';
import { Grid } from '@material-ui/core';

const ControlledPhoneWithCountryCode = props => {
  const {
    control,
    errors = {},
    loading = false,
    required = false,
    classes = {},
    phoneName = 'phone',
    phoneCountryCodeName = 'phoneCountryCode'
  } = props;

  return (
    <Grid container justifyContent="flex-end" className={classes.root}>
      <Grid
        item
        xs={5}
        sm={5}
        container
        justifyContent="center"
        className={classes.countryCodeInput}
      >
        <ControlledNumberInput
          control={control}
          name={phoneCountryCodeName}
          id="ControlledPhoneWithCountryCode_form_input_phoneCountryCode"
          autoComplete="tel-country-code"
          required={required}
          InputProps={{
            startAdornment: <FlagColombia size={20} style={{ flexShrink: 0 }} />
          }}
          format="+###"
          placeholder="57"
          fullWidth
          label="Prefijo"
          disabled={loading}
          error={Boolean(errors[phoneCountryCodeName])}
          helperText={
            errors[phoneCountryCodeName] && errors[phoneCountryCodeName].message
          }
          margin="none"
        />
      </Grid>
      <Grid item xs={7} sm={7} className={classes.phoneInput}>
        <ControlledNumberInput
          control={control}
          name={phoneName}
          id="ControlledPhoneWithCountryCode_form_input_phone"
          autoComplete="tel-local"
          required={required}
          fullWidth
          margin="none"
          label="Número celular"
          disabled={loading}
          error={Boolean(errors[phoneName])}
          helperText={errors[phoneName] && errors[phoneName].message}
        />
      </Grid>
    </Grid>
  );
};

export default ControlledPhoneWithCountryCode;
